import React,{useEffect,useContext,useState} from 'react';
import AdminLayout from './AdminLayout';
import CartaContext from '../../context/cartaContext/cartaContext';
import AuthContext from '../../context/authContext/authContext';
import AdminContext from '../../context/adminContext/adminContext';
import ExpandMoreIcon from '@material-ui/icons/ExpandMoreOutlined';
import MuiAlert from '@material-ui/lab/Alert';
import {Container,
        Stepper,
        Step,
        StepLabel,
        StepContent,
        Typography,
        Button,
        makeStyles,
        FormControl,
        RadioGroup,
        Accordion,
        AccordionDetails,
        AccordionSummary,
        FormControlLabel,
        Radio,
        CircularProgress,
        FormGroup,
        Checkbox,
        TextField,
        Grow,
        Card,
        CardContent,
        Backdrop,
        Dialog,
        DialogContentText,
        DialogContent,
        DialogActions,
        DialogTitle,
        Snackbar,
        Paper
        
        
            } from '@material-ui/core';


const useStyles = makeStyles((theme) =>({
    radio : {
        display : 'flex',
        flexDirection : 'column',
        textTransform : 'capitalize',
        padding : '4px 8px 8px',
        width : '100%',
        [theme.breakpoints.up('sm')] : {
            flexDirection : 'row',
            flexWrap : 'wrap'
        }
        
        
    },
    form : {
        textTransform : 'capitalize',
        
    },
    grupoRadio : {
        width : '100%'
    },
    stepper :{
        padding : '10px',
        marginTop : '10px'
    },
    botonera : {
        padding : '5px',
        margin: '5px',
        '& button' : {
            margin : '.8rem'
        }
    },
    circular : {
        position : 'relative',
        left: '300%',
        margin : '0 auto',
        [theme.breakpoints.up('sm')] : {
            left : '600%',
        }
    },
    precio : {
        fontWeight : 'bold',
        color: "black"
    },
    card : {
        margin : '1rem'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },
    bebida : {
        width : '100%',
        display : 'flex',
        justifyContent : 'space-between',
        alignItems:'center'
    },
    bebida_input : {
        width : '15%',
        marginLeft : '1rem',
    },
    area : {
        marginTop : '1rem',
        '& textarea ':{
            resize: 'none',
            width : '100%'
          }
    },
    cabecera : {
        
        [theme.breakpoints.up('md')]: {
            fontSize : "16px"
        } 
    },
    titulo : {
        textTransform : 'uppercase',
        textAlign : 'center'
    },
    descripcion : {
        marginLeft : '.5rem',
        textTransform : 'capitalize'
    },
    platos : {
        display : 'flex',
        width : '100%',
        flexDirection : 'column',
        [theme.breakpoints.up('sm')] : {
            flexDirection : 'column',
            flexWrap : 'wrap'
        }
        
    },
    plato : {
        width : '100%',
        [theme.breakpoints.up('sm')] : {
            width : '45%'
        }
        
    } 
}));

function getSteps() {
    return ['Seleccionar Menu', 'Marcar ingredientes', 'Elija la/las bebidas', 'Confirmar',];
  }
  
//ALERTAS
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

const AddMenu = (props) => {
    //EXTRAER CONTEXT MENU DELIVERY 
    const cartaContext = useContext(CartaContext);
    const {
        bebidas,
        ingredientes,
        platos,
        cargando,
        obtenerMenuStock,
        } = cartaContext;
    const authContext = useContext(AuthContext);
    const {
        cliente,
        carrito,
        addCarrito,
        total_carrito,
        getCarrito,
        mensaje,
        reiniciarErrorMensaje,
        cancelarOrden,
        error,
        limpiarCarrito
            } = authContext;
    const adminContext = useContext(AdminContext)
    const {addMenuDelivery} = adminContext;        
      //STATE LOCAL
      const steps = getSteps();
      const [especial, setespecial] = useState(false);
      const [formulario, setFormulario] = useState([
          {
              platos: null,
              ingredientes : [],
              bebidas: []
          }
      ]);
      const [tipoPlato, settipoPlato] = useState();
      const [activeStep, setActiveStep] = useState(0);
      const [Open, setOpen] = useState(false);
      const [isloading, setisloading] = useState(false);
      const [cancel, setcancel] = useState(false);

    //EL EFFECT
    useEffect(() => {
        let mounted = true;
        if(mounted){
            if(!props.location.state){
                props.history.push('/admin')
            }
            if(cliente){
                getCarrito(cliente)
            }
            obtenerMenuStock()
            if(carrito.length > 0){
                setActiveStep(3)
            }
            
        }
        return function cleanup(){
            mounted = false
        }
        // eslint-disable-next-line
    }, [cliente,mensaje,carrito]);
    
  
    //CLASES
    const classes = useStyles()
     //FILTAR CATEGORIAS DE PLATOS
     const filtrar_categorias = [];
     //FILTRAR CATEGORIAS DE BEBIDAS
     const filtrar_bebidas = []
     //OBTENER CATEGORIAS DE PLATOS Y BEBIDAS
     if(!cargando && platos){
         platos.forEach(element => {
             filtrar_categorias.push(element.categoria);
             
         });
         var unique = filtrar_categorias.filter((v, i, a) => a.indexOf(v) === i); 
         
     }
     if(!cargando && bebidas){
        bebidas.forEach(element => {
             filtrar_bebidas.push(element.categoria);
             
         });
         var beb = filtrar_bebidas.filter((v, i, a) => a.indexOf(v) === i); 
         
     }
    //CREAR PASOS
    function getStepContent(step) {
        switch (step) {
          case 0:
            return <RadioGroup aria-label="gender" name="gender1" className={classes.grupoRadio}>
                        {unique ? unique.map(categoria => {
                            return  <Accordion key = {categoria} className = {classes.platos}>
                                        <AccordionSummary 
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography >{categoria}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className ={classes.radio} >
                                            {platos ? platos.map(plato => {
                                                if(plato.categoria === categoria){
                                                    return <FormControlLabel 
                                                        key={plato._id} 
                                                        value={plato._id}
                                                        name = {plato.nombre }
                                                        checked = {formulario[0].platos === plato._id ? true : false} 
                                                        control={<Radio />} 
                                                        label={`${plato.nombre}    $ ${plato.precio}`} 
                                                        onChange={platoChange}
                                                        labelPlacement = 'end'
                                                        className= {classes.plato}
                                           
                                                        />
                                                    }
                                                return null
                                                })
                                                
                                            : <div>Cargando..</div>
                                            }
                                        </AccordionDetails>
                                    </Accordion>
                        }) 
                    :<CircularProgress className={classes.circular} color="secondary" />}
           
    </RadioGroup>
          case 1:
            return  (tipoPlato === "milanesa" || tipoPlato === "hamburguesa") && (!especial) ? <FormGroup>
                        {ingredientes ? ingredientes.map(ingrediente => {
                            if(tipoPlato === "milanesa" && ingrediente.precio_milanesa ){
                
                                return <FormControlLabel
                                        key={ingrediente._id}
                                        checked = {formulario[0].ingredientes.includes(ingrediente._id)}
                                        control={<Checkbox   value={ingrediente._id} name={ingrediente.nombre} />}
                                        label={tipoPlato === "hamburguesa" ? `${ingrediente.nombre}  $ ${ingrediente.precio_hamburguesa}` 
                                                            : `${ingrediente.nombre}  $ ${ingrediente.precio_milanesa}` }
                                        onChange={ingredienteChange}
                                    />
                                }
                            if(tipoPlato === "hamburguesa" ){
                                return <FormControlLabel
                                key={ingrediente._id}
                                checked = {formulario[0].ingredientes.includes(ingrediente._id)}
                                control={<Checkbox   value={ingrediente._id} name={ingrediente.nombre} />}
                                label={tipoPlato === "hamburguesa" ? `${ingrediente.nombre}  $ ${ingrediente.precio_hamburguesa}` 
                                                    : `${ingrediente.nombre}  $ ${ingrediente.precio_milanesa}` }
                                onChange={ingredienteChange}
                            />
                            }
                            return null    
                                })
                        : <CircularProgress className={classes.circular} color="secondary" />
                        }
        
                    </FormGroup>
                    : <Typography color='error'>Al menu seleccionado no se le pueden colocar ingredientes.</Typography>
          case 2:
            return  <Paper>
            <FormGroup className={classes.listadoBebidas}>
                    {beb ? beb.map(categoria => {
                            return  <Accordion key = {categoria} className = {classes.platos}>
                                <AccordionSummary 
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                <Typography  variant="h6">{categoria === "sin_alcohol" ? "Sin Alcohol" : categoria}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className ={classes.radio} >
                                    {bebidas ? bebidas.map(bebida => {
                                        if(bebida.categoria === categoria){
                                            return <div key={bebida._id} className={classes.bebida} >
                                                <Typography style={{width : '270px'}}>{`${bebida.nombre} $ ${bebida.precio} :`}</Typography>
                                                    <div className={classes.bebida_input}>
                                                        <TextField 
                                                            id={bebida._id}
                                                            type="number"
                                                             InputLabelProps={{
                                                                    shrink: true,
                                                            }}  
                                                            onChange={bebidaChange}
                                                            name={bebida.nombre } 
                                                            inputProps={
                                                                {min : "0"}
                                                            }
                                                        />
                                                    </div>
                                                    </div>
                                        }else{
                                            return null
                                        }
                    
                                    })
                                    : <CircularProgress className={classes.circular} color="secondary" />
                                    }
                                    
                                    
                                    </AccordionDetails>
                               </Accordion>
                             
                        }) 
                        :<div className={classes.circular}><CircularProgress  color="secondary" /></div>}
        
                  
                </FormGroup>  
            </Paper>
          case 3: 
            return <>{carrito ? carrito.map(menu =>{
                return <Grow key= {menu._id} in={true}
                           
                        ><Card   className = {classes.card}>
                        <CardContent>
                          <Typography variant="h5" component="h2" className={classes.titulo} >
                                {menu.platos ? menu.platos.nombre : null}
                        </Typography>
                        <Typography  color="textSecondary">
                            Ingredientes:
                        </Typography>
                        {menu.ingredientes.length > 0 ?menu.ingredientes.map(ingre =>{
                            return <Typography key ={ingre._id}variant="body2" component="p" className={classes.descripcion}>
                                    { ingre.nombre }
                                    </Typography>
                        }) : null}
                        <Typography>
                        </Typography>
                        <Typography  color="textSecondary">
                            Bebidas:
                        </Typography>
                        {menu.bebidas.map(bebida =>{
                            return <Typography key = {bebida._id} variant="body2" component="p" className={classes.descripcion}>
                                    { bebida.nombre}
                                    </Typography>
                        })}
                        <Typography>
                            Subtotal : $ {
                               menu.subtotal
                                
                            }
                        </Typography>
                    </CardContent>
                
          </Card>
          </Grow>
        })
        : <Typography>No hay elementos en el carrito</Typography>}
      {carrito.length !== 0 ? <Typography className= {classes.precio}>PRECIO FINAL : ${total_carrito}</Typography> : <CircularProgress className={classes.circular} color="secondary" />}
                </>
          default:
            return 'Unknown step';
        }
      }    
    //DEFINIR QUE PEDIDO SE MODIFICA
    let nombre = null;
    if(props.location.state){
        if(props.location.state.pedido.cliente_registrado){
           nombre = props.location.state.pedido.cliente_registrado.nombre;
        }else{
            nombre = props.location.state.pedido.cliente_manual.nombre;
        }
    }
    //FUNCIONES
    const platoChange = (e) => {
        platos.map(plato =>{
            if(plato._id === e.target.value){
              settipoPlato(plato.categoria)
            }
            return null
      })
        
          const newArray = [];
          const plato = e.target.value;
          newArray.push({platos : plato,
                       ingredientes : [],  
                       bebidas : []
                      });
          setFormulario(newArray)
          if(e.target.value === "5fb807ca72e3cf2886f5d707" || e.target.value === "5fb807e472e3cf2886f5d708" ||  
          e.target.value === "5fb8083172e3cf2886f5d70b" || e.target.value === "5fb8084272e3cf2886f5d70c" ||
          e.target.value === "5fb8086a72e3cf2886f5d70d" || e.target.value === "5fb8088b72e3cf2886f5d70e" ||
          e.target.value === "5fc2c4deafc7b90017c6e14d" ){
              setespecial(true)
          }else{
              setespecial(false)
          }
      };
    const ingredienteChange = (e) => {
        const newArray = [...formulario]
        const ingrediente = newArray[0].ingredientes
        if (e.target.checked) {
            ingrediente.push(e.target.value);
        } else {
                const idx = ingrediente.indexOf(e.target.value);
            if(idx > -1){
                ingrediente.splice(idx, 1);
            }
            
        }
        
        newArray[0].ingredientes = ingrediente
        setFormulario(newArray)
    };
    const bebidaChange = (e) => {
      
        const newArray = [...formulario]
        const bebida = newArray[0].bebidas
        
        if(bebida.find(indx => indx === e.target.id)){
            bebida.splice(0);
            for (let index = 0; index < e.target.value; index++) {
                bebida.push(e.target.id)
            }
        }else{
            for (let index = 0; index < e.target.value; index++) {
                bebida.push(e.target.id)
            }
        }
        // if (e.target.checked) {
        //     bebida.push(e.target.value);
        // } else {
        //         const idx = bebida.indexOf(e.target.value);
        //     if(idx > -1){
        //         bebida.splice(idx, 1);
        //     }
            
        // }
        newArray[0].bebidas = bebida
         setFormulario(newArray)
    };
    const handleHome = async () => {
        setisloading(true)
        await cancelarOrden(cliente)
        setTimeout(
            function(){
                reiniciarErrorMensaje()
                props.history.push('/admin')
                setisloading(false)
            }
           ,
            2000
        )
        
    }
    const finalizarOrden = async e =>{
        //FUNCION QUE AGREGA AL CARRITO,
        setisloading(true);
        if(formulario[0].platos === null && formulario[0].ingredientes.length === 0 && formulario[0].bebidas.length === 0){
          setOpen(true)
          setisloading(false)
          return
        }
        addCarrito(formulario[0],cliente)
        //REINICIAR EL FORMULARIO
        
        setFormulario([
         {
             platos: null,
             ingredientes : [],
             bebidas: []
         }
         ]);
         
        
         setisloading(false)
         handleNext()
      
     }
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      };
    
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      };
    
    //REINICIAR MENSAJES
    const handleReset = () =>{
        reiniciarErrorMensaje()
    }
    const handleClose = () => {
        setActiveStep(0)
        setFormulario([
            {
                platos: null,
                ingredientes : [],
                bebidas: []
            }
            ]);
        setOpen(false)
    };
    const agregarMenu = async (pedido,menu) => {
        setisloading(true)
        await addMenuDelivery(pedido,menu)
        limpiarCarrito(cliente)
        setTimeout(
            function(){
                props.history.push('/admin')
                setisloading(false)
            }
           ,
            2000
        )
        
    }
 
    return ( 
        <AdminLayout>
            <Backdrop className={classes.backdrop} open={isloading} onClick={handleClose}>
                <CircularProgress color="inherit" />
              </Backdrop>
              
              <Snackbar open={mensaje ? true : false} autoHideDuration={3000} 
                        onClose={handleReset}
                        anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
                <Alert onClose={handleReset} severity="success">
                    {mensaje}
                </Alert>
                </Snackbar>
                <Snackbar open={error} autoHideDuration={6000} 
                        onClose={handleReset}
                        anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
                    <Alert onClose={handleReset} severity="error">
                        {mensaje}
                    </Alert>
                </Snackbar>
            <Container maxWidth = 'lg'>
            <Dialog
                open={Open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"ADVERTENCIA"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Esta intentando agregar un menu sin un Plato y sin Bebida.
                        Si considera que esto es un error seleccione "Cargar Menu" para reintentar , caso contrario seleccione "Volver a los Pedidos"
                        para regresar al menu principal
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleHome} color="primary">
                            Volver a los pedidos
                    </Button>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Cargar un menu
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={cancel}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"ADVERTENCIA"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Desea cancelar la modificacion?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setcancel(false)} color="primary">
                            No
                    </Button>
                    <Button onClick={handleHome} color="primary" autoFocus>
                       Si
                    </Button>
                </DialogActions>
            </Dialog>
                <Typography variant='h5'>Agregar menu para {nombre}</Typography> 
                <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    <StepContent>
                        <FormControl component="fieldset" className={classes.form} >
                                            {getStepContent(index)}
                        </FormControl >
                        <div className={classes.botonera}>
                        {activeStep < steps.length - 2 ? <div>
                            <Button
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            
                        >
                            Atras
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                   
                        >
                            Siguiente
                        </Button>
                        </div> : null}
                        {activeStep === 2 ? <div>
                            <Button
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            
                        >
                            Atras
                        </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={finalizarOrden}
                   
                            >
                            Cargar menu
                            </Button>
                        </div> : null}
                        {activeStep === 3 ? <div>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setcancel(true)}
                                >
                                Cancelar 
                            </Button>
                            <Button
                                 variant="contained"
                                 color="primary"
                                 onClick={() =>agregarMenu(props.location.state.pedido , carrito)}
                                >
                                Confirmar
                            </Button>
                        </div> : null}
                        </div>
              
            </StepContent>
          </Step>
        ))}
      </Stepper>
            </Container>
           
        </AdminLayout>
     );
}
 
export default AddMenu;